import { pctChange } from "./format";

export const SEVERITY_RANK = { critical: 3, high: 2, medium: 1 };

export const ENTITY_TYPES = [
    { value: "all", label: "All types" },
    { value: "Page", label: "Pages" },
    { value: "Section", label: "Sections" },
    { value: "Query", label: "Queries" },
    { value: "Device", label: "Devices" },
    { value: "Country", label: "Countries" },
];

/** The causes the drops have, for the cause filter. */
export const causeOptionsOf = (drops) => [
    { value: "all", label: "All causes" },
    ...[...new Set(drops.map((drop) => drop.cause))].map((cause) => ({ value: cause, label: cause })),
];

/** What the drops are read by, `?measure=`; impressions by default, as on the Issues page. */
export const MEASURES = [
    { value: "impressions", label: "Impressions", unit: "impressions" },
    { value: "clicks", label: "Clicks", unit: "clicks" },
    { value: "sessions", label: "Sessions", unit: "sessions" },
];
export const DEFAULT_MEASURE = "impressions";
export const measureOf = (value) => MEASURES.find((measure) => measure.value === value) ?? MEASURES[0];

export const lostOf = (drop, measure) => drop.byMeasure[measure].before - drop.byMeasure[measure].after;
export const changeOf = (drop, measure) => pctChange(drop.byMeasure[measure].before, drop.byMeasure[measure].after);
export const isUrlEntity = (drop) => drop.entityType === "Page" || drop.entityType === "Section";
export const displayEntity = (drop) => (drop.entityType === "Query" ? `“${drop.entity}”` : drop.entity);

const csvCell = (value) => {
    const text = String(value);
    return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export function exportDropsCsv(drops, domain, measure) {
    const { label } = measureOf(measure);
    const header = ["Severity", "Affected", "Type", "Likely cause", `${label} before (7d)`, `${label} after (7d)`, "Change %", "Avg position before", "Avg position after", "Started", "Next step"];
    const rows = drops.map((drop) => [
        drop.severity, drop.entity, drop.entityType, drop.cause, drop.byMeasure[measure].before, drop.byMeasure[measure].after, changeOf(drop, measure).toFixed(1),
        drop.position.before, drop.position.after, drop.detectedAt, drop.nextStep,
    ]);
    const csv = [header, ...rows].map((row) => row.map(csvCell).join(",")).join("\n");
    const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
    const link = document.createElement("a");
    link.href = url;
    link.download = `${domain}-drops.csv`;
    link.click();
    URL.revokeObjectURL(url);
}
